export function insertHtmlSnippet(
    editor: HTMLElement | null,
    target: HTMLElement | null,
    position: 'before' | 'after',
    htmlSnippet: string,
    wrapperTag = 'div'
) {
    if (!editor || !target || !editor.contains(target)) return;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlSnippet;

    const wrapper = document.createElement(wrapperTag);
    while (tempDiv.firstChild) {
        wrapper.appendChild(tempDiv.firstChild);
    }

    const parentNode = target.parentNode;
    if (!parentNode) return;

    if (position === 'before') {
        parentNode.insertBefore(wrapper, target);
    } else {
        parentNode.insertBefore(wrapper, target.nextSibling);
    }

    const movedNodes: Node[] = [];
    while (wrapper.firstChild) {
        const node = wrapper.firstChild;
        movedNodes.push(node);
        parentNode.insertBefore(node, wrapper);
    }
    parentNode.removeChild(wrapper);

    const last = movedNodes[movedNodes.length - 1];
    if (last) {
        const sel = window.getSelection();
        const newRange = document.createRange();
        try {
            newRange.setStartAfter(last);
        } catch {
            newRange.selectNodeContents(last);
            newRange.collapse(false);
        }
        sel?.removeAllRanges();
        sel?.addRange(newRange);
    }
}
